module.exports = __webpack_public_path__ + "img/auto.3417407d.svg";